import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'move-record-item',
  templateUrl: './move-record-item.component.html',
  styleUrls: ['./move-record-item.component.less'],
})
export class MoveRecordItemComponent implements OnInit {
  /**
   * 异动记录详情信息
   */
  @Input() data: object = {};
  /**
   * 当前字段所对应的key
   */
  @Input() key: string = '';
  /**
   * 当前信息的数据类型是否是创建
   */
  @Input() isCreate: boolean = true;
  /**
   * 字段对应的名称及展示方式
   */
  @Input() keys: object = {};
  /**
   * 展示数据的数量
   */
  @Input() showNumber: number = 2;
  /**
   * 修改或者创建标题
   */
  @Input() title: string = '';
  objectKeys = Object.keys;
  record: Array<object> = [];

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] != undefined || changes['keys'] != undefined) {
      this.dealRecord(this.data, this.keys);
    }
  }

  /**
   * 处理校对信息
   */
  dealRecord(data: object, keys: object): void {
    const record = [];
    // tslint:disable-next-line:forin
    for (const i in keys) {
      if (data[i] != undefined) {
        if (keys[i]['type'] == 'text') {
          // 判断字段的类型是否是文字
          record.push({ title: keys[i]['title'], value: data[i], type: keys[i]['type'] });
        } else if (keys[i]['type'] == 'join') {
          if (this.isCreate) {
            record.push({
              title: keys[i]['title'],
              value: data[keys[i]['keys'][0]] + '~' + data[keys[i]['keys'][1]],
              type: 'text',
            });
          } else {
            record.push({
              title: keys[i]['title'],
              value: {
                old: data[keys[i]['keys'][0]]['old'] + '~' + data[keys[i]['keys'][1]]['old'],
                new: data[keys[i]['keys'][0]]['new'] + '~' + data[keys[i]['keys'][1]]['new'],
              },
              type: 'text',
            });
          }
        } else if (keys[i]['type'] == 'image') {
          record.push({
            title: keys[i]['title'],
            value: data[i],
            type: keys[i]['type'],
          });
        } else if (keys[i]['type'] == 'map') {
          record.push({
            title: keys[i]['title'],
            value: {
              old: data[keys[i]['keys'][0]]['old'] + ',' + data[keys[i]['keys'][1]]['old'],
              new: data[keys[i]['keys'][0]]['new'] + ',' + data[keys[i]['keys'][1]]['new'],
            },
            type: 'text',
          });
        } else if (keys[i]['type'] == 'textArray') {
          const value =
            data['usci'] && data['usci']['new']
              ? {
                  new: data['usci'].new.join('、'),
                  old: JSON.parse(data['usci'].old).join('、'),
                }
              : data['usci'].join('、');
          try {
            record.push({
              title: keys[i].title,
              value,
              type: 'text',
            });
          } catch (error) {
            console.log(error, data);
          }
        }
      }
      if (record.length + 1 > this.showNumber && this.showNumber != 0) {
        break;
      }
    }
    this.record = [...record];
  }
}
